import React from "react";
import SideNavLink from "../../shared/SideNavLink";
import { isCoreLimitEnforced } from "../../shared/performanceUtils";
import config from "../../config";

const PANEL_CONFIGS = [2, 4, 6, 9, 12, 16];

function SideNavLinks(props) {
  const links = getSideNavLinks({
    ...props,
    panelConfigArray: PANEL_CONFIGS,
    config,
  }).filter(
    (sideNavLink) =>
      sideNavLink.visible &&
      isCoreLimitEnforced(sideNavLink.minimumRequiredCores),
  );
  return (
    <>
      {links.map((props) => (
        <SideNavLink {...props} key={props.href} />
      ))}
    </>
  );
}

export function getSideNavLinks({
  showPatientList,
  splitScreen,
  togglePatientList,
  selectLayout,
  panelConfigArray,
  parent,
  config,
}) {
  const baselineSideNav = [
    {
      href: "patient-list",
      selected: showPatientList,
      icon: "list",
      onClick: togglePatientList,
      visible: !parent?.store.isCustomBedList,
      minimumRequiredCores: 1,
    },
    {
      href: "multi",
      selected: !splitScreen,
      icon: "multi",
      onClick: selectLayout,
      visible: true,
      minimumRequiredCores: 1,
    },
  ];

  const panelConfigurations = panelConfigArray.map((panelConfig) => {
    const checkSplit = (value) => splitScreen === value;
    const handleClick = (e) => {
      selectLayout(e, panelConfig);
    };
    const handleVisibility = () => {
      if (panelConfig === 12) {
        return !config.hideMpv12;
      } else if (panelConfig === 16) {
        return !config.hideMpv16;
      } else {
        return true;
      }
    };

    return {
      href: `${panelConfig}`,
      selected: checkSplit(panelConfig),
      text: `${panelConfig}`,
      onClick: handleClick,
      visible: handleVisibility(),
      minimumRequiredCores: panelConfig,
    };
  });
  return baselineSideNav.concat(panelConfigurations);
}

export default SideNavLinks;
